import { render, staticRenderFns } from "./Glasses.vue?vue&type=template&id=62fd06dc&scoped=true&"
import script from "./Glasses.vue?vue&type=script&lang=js&"
export * from "./Glasses.vue?vue&type=script&lang=js&"
import style0 from "./Glasses.vue?vue&type=style&index=0&id=62fd06dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd06dc",
  null
  
)

export default component.exports